const actions = {
  GET_LOAD: 'GET_LOAD',
  GET_SUCCESS: 'GET_SUCCESS',
  GET_ERROR: 'GET_ERROR',

  getLoad: () => {
    return { type: actions.GET_LOAD };
  },
  getSuccess: (diagnostic) => {
    return { type: actions.GET_SUCCESS, diagnostic };
  },
  getErr: (err) => {
    return { type: actions.GET_ERROR, err };
  },

  GET_EXCEL_LOAD: 'GET_EXCEL_LOAD',
  GET_EXCEL_SUCCESS: 'GET_EXCEL_SUCCESS',
  GET_EXCEL_ERROR: 'GET_EXCEL_ERROR',

  getExcelLoad: () => {
    return { type: actions.GET_EXCEL_LOAD };
  },
  getExcelSuccess: (diagnostic) => {
    return { type: actions.GET_EXCEL_SUCCESS, diagnostic };
  },
  getExcelErr: (err) => {
    return { type: actions.GET_EXCEL_ERROR, err };
  },
};

export default actions;
